import React from 'react';
import {View, Text, TouchableOpacity} from 'react-native';
import {globalFontStyle, globalStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import FormTextLabel from "../../../commonComponents/FormTextLabel";
import {globalConfigurableData} from "../../../utils/globalConstant";

const DeleteModal = ({onOptionClick, onBottomSheetClose}) => {
  return (
    <View style={{padding: 25}}>
      <FormTextLabel
        labelStyles={{
            ...globalFontStyle.appFontHeading,
            marginBottom: 10,
            color: globalConfigurableData.primaryTextColor1,
        }}
        label={"Log Out"}
      />
      <FormTextLabel
        labelStyles={{...globalFontStyle.appFontSubText, color: globalConfigurableData.tertiaryTextColor1}}
        label={"Are you sure you want to log out?"}
      />
      <View
        style={{
          marginTop: 25,
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}>
        <TouchableOpacity
          onPress={onOptionClick}
          style={globalStyle.circleMainBtnForm}>
          <FormTextLabel
            labelStyles={{color: globalConfigurableData.contrastTextColor1}}
            label={"Yes, log me out"}
          />
        </TouchableOpacity>
        <TouchableOpacity
          style={{marginHorizontal: 20, marginVertical: 0}}
          onPress={onBottomSheetClose}>
          <FormTextLabel
            labelStyles={{
                ...globalFontStyle.appFontSubText,
                color: globalConfigurableData.primaryTextColor1,
            }}
            label={" Cancel"}
          />
        </TouchableOpacity>
      </View>
    </View>
  );
};

export default DeleteModal;
